export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/wddt-99ece2613690a75b8b80f3f11a9e7d85.png";